export default __webpack_public_path__ + "42b5b355bb3922d8d554fa51ede88443.png";